module.exports = __webpack_public_path__ + "static/somersette-ea19e8667877660bd08d2694215f5c4f.woff";